<template>
  <div>
    <modal
      centered
      :show.sync="localOpen"
      id="addAudiance"
      bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2"
    >
      <div slot="header" class="border-bottom pb-3 w-100">
        <h3 class="title title-up">Upload Audience</h3>
      </div>
      <div
        class="row col-sm-12 col-md-12 col-lg-12 d-flex align-items-center"
        style="gap:20px"
      >
        <div class="w-100 col-12 col-md-6 col-lg-12">
          <base-input
            label="Audience Name"
            type="text"
            placeholder="e.g., Summer campaign Audience"
            v-model="audianceName"
            :maxlength="56"
            class="mb-0 pb-0"
          >
          </base-input>
        </div>
        <div class="w-0 col-12 col-md-6 col-lg-12 mb-3"> 
          <label>{{
            CompanyNamedisabled ? "Client Name" : "Select Client Name"
          }}</label>
          <el-select
            class="select__form__client w-100"
            size="large"
            placeholder="Select Client Name"
            v-model="selectedCompany"
            :disabled="CompanyNamedisabled"
            @change="onCompanyChange(selectedCompany)"
          >
            <el-option
              v-for="option in companyList"
              :value="option.id"
              :label="option.company_name"
              :key="option.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
        <div class="d-flex align-items-center justify-content-between">
          <span
            class="font-weight-600 text-dark"
            style="
    font-size: 16px;
"
            >Local Audience List</span
          >
          <a href="/samplefile/sample.csv" download>
            <el-button
              class="upload-button"
              icon="el-icon-download"
              plain
            >
              Download Sample CSV
            </el-button>
          </a>
        </div>
        <el-upload
          action="#"
          class="audiance-upload w-100 mt-2"
          drag
          ref="upload"
          :auto-upload="false"
          :on-change="handleChange"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text w-100">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip d-flex flex-column" slot="tip">
            <span>A csv file adhering to our format, see sample above.</span>
            <span>Required fields: address, city-state,zip</span>
            <span>Optional fields: latitude, longitude</span>
            <span>Can only upload 1 file and maximum size 1 mb</span>
          </div>
        </el-upload>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
        <el-checkbox
          class="checkbox-advanced-information text-wrap d-flex align-items-center text-dark-50 --audiance-upload-aggrement"
          style="font-size: 12px;"
          label="By uploading physical addresses or other data, you warrant and represent that you (“customer”) own the information and have the right to collect and use the information for the marketing purposes in accordance with applicable laws."
          v-model="isAggreed"
          >By uploading physical addresses or other data, you warrant and
          represent that you (“customer”) own the information and have the right
          to collect and use the information for the marketing purposes in
          accordance with applicable laws.</el-checkbox
        >
      </div>
      <template slot="footer">
        <div
          class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap"
          style="gap:8px"
        >
          <base-button :disabled="isUploadAudiance" size="sm" :id="'btnSave'" style="height:40px" @click="uploadAudiance">
            Upload
            <i v-if="isUploadAudiance" class="fas fa-spinner fa-spin ml-2" style="font-size: 18px;"></i>
          </base-button>
          <base-button
            :disabled="isUploadAudiance"
            @click="localOpen = false"
            simple
            size="sm"
            style="height:40px"
          >
            Cancel
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "src/components";
import { Select, Option, Upload, Button, Checkbox } from "element-ui";
import { required } from "vee-validate/dist/rules";
import axios from 'axios';
export default {
  components: {
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      audianceName: "",
      selectedCompany: "",
      fileList: [],
      isAggreed: false,
      isUploadAudiance: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    CompanyNamedisabled: {
      type: Boolean,
      required: true
    },
    companySelected: {
      type: String,
      required: true
    },
    companyList: {
      type: Array,
      required: true
    }
  },
  computed: {
    localOpen: {
      get() {
        this.selectedCompany = this.companySelected;
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted() {
    this.selectedCompany = this.companySelected;
  },
  methods: {
    refresh(){
      this.audianceName = "";
      this.selectedCompany = this.companySelected;
      this.fileList = [];
      this.isAggreed = false;
      this.isUploadAudiance = false;
      this.$refs.upload.clearFiles();
    },
    onCompanyChange(_companySelected){
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].id == _companySelected) {
          this.selectedCompany = this.companyList[
            i
          ].company_name;
        }
      }
    },
    uploadAudiance() {
      // console.log('uploadAudiance', {
      //   'fileList': this.fileList,
      //   'selectedCompany': this.selectedCompany // user id
      // });
      // validation
      if(this.audianceName.trim() == '') { // jika audiance name nya kosong
        this.$notify({ 
          type: 'danger', 
          message: 'input audiance name required', 
          icon: 'fas fa-bug'
        });
        return;
      }
      
      if(!this.selectedCompany) { // jika company client tidak dipilih
        this.$notify({ 
          type: 'danger', 
          message: 'selected client required', 
          icon: 'fas fa-bug'
        });
        return;
      }

      if(this.fileList.length == 0) {
        this.$notify({ 
          type: 'danger', 
          message: 'upload file is required', 
          icon: 'fas fa-bug'
        });
        return;
      }

      if(!this.isAggreed) {
        this.$notify({ 
          type: 'danger', 
          message: 'please check aggree', 
          icon: 'fas fa-bug'
        });
        return;
      }

      // console.log({
      //   'this.selectedCompany': this.selectedCompany,
      //   'this.companyList': this.companyList
      // });
      const selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
      if(!user_id) {
        this.$notify({ 
          type: 'danger', 
          message: 'user id not found', 
          icon: 'fas fa-bug'
        });
        return;
      }
      // validation

      // process axios
      this.isUploadAudiance = true;
      // const formData = new FormData();
      // formData.append('audiance_name', this.audianceName);
      // formData.append('user_id', user_id);
      // formData.append('file', this.fileList[0].raw);

      // this.$store.dispatch('SimplifiAudienceUpload', formData).then(response => {
      //     this.isUploadAudiance = false;
      //     this.$notify({ 
      //       type: 'success', 
      //       message: 'add audience successfully', 
      //       icon: 'tim-icons icon-bell-55'
      //     });

      // }, error => {
      //   this.isUploadAudiance = false;
      //       this.$notify({ 
      //         type: 'danger', 
      //         message: message, 
      //         icon: 'fas fa-bug'
      //       });
      // })



      const formData = new FormData();
      formData.append('audiance_name', this.audianceName);
      formData.append('user_id', user_id);
      formData.append('file', this.fileList[0].raw);
      // process axios
      
      // axios.post(process.env.VUE_APP_DATASERVER_URL + '/api/leadspeek/audience/create', formData)
      axios.post(process.env.VUE_APP_APISERVER_URL + '/api/audiance/upload', formData)
           .then(response => {
            this.localOpen = false;
            this.isUploadAudiance = false;
            this.$emit('upload-finished', response.data.media_id);
            this.refresh();
            this.$notify({ 
              type: 'success', 
              message: 'add audience successfully', 
              icon: 'fas fa-bug'
            });

           })
           .catch(error => {
            const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'something wrong please try again';
            
            this.isUploadAudiance = false; 
            this.$notify({ 
              type: 'danger', 
              message: message, 
              icon: 'fas fa-bug'
            });
      });
    },
    handleChange(file, fileList) {
      // validation
      const isFileCsv = file.type === 'text/csv' || file.name.endsWith('.csv');
      const isFileUnder1Mb = file.size / 1024 / 1024 <= 1;

      if (!isFileCsv || !isFileUnder1Mb) {
        // Hapus hanya file baru dari daftar file internal Element UI
        const lastIndex = this.$refs.upload.uploadFiles.length - 1;
        this.$refs.upload.uploadFiles.splice(lastIndex, 1); // hanya hapus yang baru

        this.$notify({ 
          type: 'danger', 
          message: !isFileCsv ? 'file type must be csv.' : 'file size must be under or equal to 1mb.', 
          icon: 'fas fa-bug'
        });
        return;
      }
      // validation
      
      this.fileList = [file];
      this.$refs.upload.uploadFiles.splice(0, this.$refs.upload.uploadFiles.length); // bersihkan file internal di element ui nya
      
      // console.log('handleChange', {
      //   'this.fileList': this.fileList,
      //   'this.$refs.upload.uploadFiles.length': this.$refs.upload.uploadFiles.length
      // });
    },
    handleRemove() {},
    handlePreview() {}
  },
  watch: {
    localOpen(newValue) {
      if(!newValue) {
        this.$refs.upload.clearFiles();
        this.fileList = [];
      }
    }
  }
};
</script>

<style lang="scss">
.audiance-upload .el-upload-dragger {
  width: 100%;
}

.audiance-upload .el-upload {
  width: 100%;
}

.--audiance-upload-aggrement .el-checkbox__label {
  font-size: 12px;
  color: rgba(34, 42, 66, 0.5) !important;
}
</style>
